module.exports = __webpack_public_path__ + "static/media/12.a792144b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/12.png
// module id = 793
// module chunks = 0